import React, {useState} from 'react'
import {Grid, Typography, TextField} from '@material-ui/core'

import CustomButton from '../../components/Button/Button'
import emailjs from 'emailjs-com'
import {store} from 'react-notifications-component'

import resumeData from '../../utils/resumeData'
import './Contacts.css'
import 'react-notifications-component/dist/theme.css'

const Contacts = () => {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')

  function handleSubmit(e) {
    e.preventDefault()

    emailjs
      .sendForm(
        resumeData.emailJS.serviceId,
        resumeData.emailJS.templateId,
        e.target,
        resumeData.emailJS.userId
      )
      .then(
        result => {
          console.log(result.text)
          store.addNotification({
            title: 'Message sent!',
            message: 'I will contact you ASAP.',
            type: 'success',
            insert: 'top',
            container: 'bottom-center',
            animationIn: ['animated', 'fadeIn'],
            animationOut: ['animated', 'fadeOut'],
            dismiss: {
              duration: 4000,
              onScreen: false,
              showIcon: true,
            },
          })
          setName('')
          setEmail('')
          setMessage('')
        },
        error => {
          console.log(error.text)
          store.addNotification({
            title: 'Error',
            message: 'Please, try again later.',
            type: 'danger',
            insert: 'top',
            container: 'bottom-center',
            animationIn: ['animated', 'fadeIn'],
            animationOut: ['animated', 'fadeOut'],
            dismiss: {
              duration: 4000,
              onScreen: false,
              showIcon: true,
            },
          })
        }
      )
  }

  return (
    <>
      {/* Contact */}
      <Grid container spacing={5} className="section pb-45 pt-45">
        {/*Contact Form*/}
        <Grid item xs={12} lg={7}>
          <Grid container>
            <Grid item className="section-title mb-30">
              <span></span>
              <h6 className="section-title-text">Contact with me</h6>
            </Grid>
            <form onSubmit={handleSubmit}>
              <Grid item xs={12}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      name="name"
                      label="Name"
                      value={name}
                      onInput={e => setName(e.target.value)}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      name="email"
                      label="Your e-mail"
                      value={email}
                      onInput={e => setEmail(e.target.value)}
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      name="message"
                      label="Message"
                      multiline
                      rows={8}
                      value={message}
                      onInput={e => setMessage(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <CustomButton text="Submit" type="submit" />
                  </Grid>
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>

        {/*Contact Information*/}
        <Grid item xs={12} lg={5}>
          <Grid container spacing={2}>
            <Grid item className="section-title mb-30">
              <span></span>
              <h6 className="section-title-text">Contact Information</h6>
            </Grid>

            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={12}>
                  <Typography className="contact-info-item">
                    <span>Address: </span> {resumeData.address}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography className="contact-info-item">
                    <span>Email: </span> {resumeData.email}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography className="contact-info-item">
                    <span>Phone: </span> {resumeData.phone}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid container className="contact-info-socials-container">
                {Object.keys(resumeData.socials).map(key => (
                  <Grid item className="contact-info-social">
                    <a href={resumeData.socials[key].url}>
                      {resumeData.socials[key].icon}
                    </a>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default Contacts
